module.exports = __webpack_public_path__ + "static/img/5.602bfcc5.png";